export const salarie = {
  profil : 'Salarié',
  firstname : "Jean-Jacques",
  name : "Dupont",
  pack: [
    {
      type: 'Santé',
      slug: 'sante',
      link: '/salarie/mes-garanties',
      current : {
        name: 'Vikater',
        option: 'A3',
        support: '75%',
        details: [
          {
            title : 'ISOLÉ (SALARIÉ)',
            type : 'costs',
            costs: [
              {
                title: 'employeur',
                price: 76,
                total: 921
              },
              {
                title: 'salarié',
                price: 19,
                total: 228
              }
            ]
          },
          {
            title : 'FAMILLE',
            type : 'costs',
            costs: [
              {
                title: 'employeur',
                price: 177,
                total: 487
              },
              {
                title: 'salarié',
                price: 41,
                total: 228
              }
            ]
          },
          {
            title : 'NIVEAU DE COUVERTURE',
            type: 'cover',
            value : 5
          }
        ],
        documents: [
          { title: 'Tableaux de garanties', link: '#'},
          { title: 'Notice', link: '#'},
        ],
        btn : {
          link: '/',
          text : "Je modifie mes options Santé"
        }
      },
    },
    {
      type: 'Prévoyance',
      slug: 'prevoyance',
      link: '/salarie/mes-garanties',
      current : {
        name: 'Exklusif Ekilibre',
        details: [
          {
            title : 'ISOLÉ (SALARIÉ)',
            type : 'costs',
            costs: [
              {
                title: 'employeur',
                price: 76,
                total: 921
              },
              {
                title: 'salarié',
                price: 19,
                total: 228
              }
            ]
          },
        ],
        documents: [
          { title: "Notice d'informations", link: '#'},
        ]
      }
    },
    {
      type: 'Dépendance',
      slug: 'dependance',
      link: '/salarie/mes-garanties',
      current : {
        name: 'KEREO',
        details: [
          {
            title : 'ISOLÉ (SALARIÉ)',
            type : 'costs',
            costs: [
              {
                title: 'employeur',
                price: 76,
                total: 921
              },
              {
                title: 'salarié',
                price: 19,
                total: 228
              }
            ]
          },
        ],
        documents: [
          { title: "Tableau de garanties", link: '#'},
          { title: "Notice d'informations", link: '#'},
        ]
      }
    },
    {
      type: 'Retraite',
      slug: 'retraite',
      link: '/salarie/mes-garanties',
      current : {
        name: 'KONFORTIS',
        documents: [
          { title: "Notice d'informations", link: '#'},
        ],
        btn : {
          link: '/',
          text : "J’accède à la rubrique Ma retraite"
        }
      }
    }
  ],
  beneficiaries : [
    {
      name : 'Louise Brouquier',
      relation : 'Conjoint',
      cover : ['sante', 'prevoyance'],
      birthdate: '25/08/1987',
      gestion: '189219080',
      options: [ 'option 1', 'option 2', 'option 3']
    },
    {
      name : 'Donald Brouquier',
      relation : 'Enfant 1',
      cover : ['sante', 'prevoyance'],
      birthdate: '12/08/2020',
      gestion: '189219080',
      options: [ 'option 1', 'option 2']
    },
    {
      name : 'Adeline Brouquier',
      relation : 'Enfant 2',
      cover : ['sante'],
      birthdate: '03/02/2012',
      gestion: '189219080',
      options: [ 'option 1']
    },
  ],
  demandes: [
    {
      demande_status: 'uncomplete',
      demande_date: '16/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_beneficiary: 'Vincent Goncalves',
      demande_price: '800',
    },
    {
      demande_status: 'progressing',
      demande_date: '16/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_beneficiary: 'Vincent Goncalves',
      demande_price: '500'
    },
    {
      demande_status: 'uncomplete',
      demande_date: '16/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_beneficiary: 'Vincent Goncalves',
      demande_price: '500'
    },
    {
      demande_status: 'clotured',
      demande_date: '16/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_beneficiary: 'Vincent Goncalves',
      demande_price: '500'
    },
    {
      demande_status: 'clotured',
      demande_date: '16/02/2022',
      demande_motif: 'Remboursement IFC',
      demande_beneficiary: 'Vincent Goncalves',
      demande_price: '800'
    }
  ],
  refunds: [
    {
      refund_status: 'clotured',
      refund_date: '16/02/2022',
      refund_type: 'Remboursement IFC',
      refund_beneficiary: 'Vincent Goncalves',
      refund_price: '800',
      refund_complete: 'Complet'
    },
    {
      refund_status: 'progressing',
      refund_date: '16/02/2022',
      refund_type: 'Remboursement IFC',
      refund_beneficiary: 'Vincent Goncalves',
      refund_price: '800',
      refund_complete: 'Complet'
    },
    {
      refund_status: 'clotured',
      refund_date: '16/02/2022',
      refund_type: 'Remboursement IFC',
      refund_beneficiary: 'Vincent Goncalves',
      refund_price: '800',
      refund_complete: 'Complet'
    },
    {
      refund_status: 'clotured',
      refund_date: '16/02/2022',
      refund_type: 'Remboursement IFC',
      refund_beneficiary: 'Vincent Goncalves',
      refund_price: '800',
      refund_complete: 'Complet'
    },
    {
      refund_status: 'clotured',
      refund_date: '16/02/2022',
      refund_type: 'Remboursement IFC',
      refund_beneficiary: 'Vincent Goncalves',
      refund_price: '800',
      refund_complete: 'Complet'
    }
  ]
}
